import i18n from "@/i18n/i18n"

export const MenuTypeOptions = [
  {
    label: i18n.t('菜单'),
    value: '1'
  },
  {
    label: i18n.t('按钮'),
    value: '2'
  },
]

export const yesOrNoOptions = [
  {
    label: i18n.t('是'),
    value: '1'
  },
  {
    label: i18n.t('否'),
    value: '0'
  },
]

export const menuAuthTypeOptions = [
  {
    label: i18n.t('登录认证'),
    value: '1'
  },
  {
    label: i18n.t('无验证'),
    value: '0'
  },
]

export const roleTypeOptions = [
  {
    label: i18n.t('自定义'),
    value: '0'
  },
  {
    label: i18n.t('默认'),
    value: '1'
  },
]